import { createContainer } from 'react-tracked';
import { useReducer } from 'react';

const initialState = {
    showInvestmentNoteDetailsModal: false,
    investmentNote: undefined,
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'closeInvestmentNoteDetailsModal':
            return {
                ...state,
                showInvestmentNoteDetailsModal: false,
            };
        case 'viewInvestmentNoteDetails':
            return {
                ...state,
                showInvestmentNoteDetailsModal: true,
                investmentNote: action.investmentNote,
            };
        default:
            return state;
    }
};

const useValue = () => useReducer(reducer, initialState);

export const {
    Provider: InvestmentNoteProvider,
    useTrackedState: useInvestmentNoteState,
    useUpdate: useInvestmentNoteDispatch,
} = createContainer(useValue);
